import { render } from "./Client.vue?vue&type=template&id=73ac8f94"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/efakturastat.dev.oneit.rs/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/views/Client.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73ac8f94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73ac8f94', __exports__)) {
    console.log('reload')
    api.reload('73ac8f94', __exports__)
  }
  
  module.hot.accept("./Client.vue?vue&type=template&id=73ac8f94", () => {
    console.log('re-render')
    api.rerender('73ac8f94', render)
  })

}


export default __exports__